import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Checkbox from './Checkbox';
import { inviteeRSVPChanged } from '../actions/invitee';
import './RSVP.css';

const mapStateToProps = state => ({
  names: state.invitee.names,
  events: state.invitee.events,
  inviteeId: state.invitee.id,
  blueTeamMember: state.invitee.ba,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ inviteeRSVPChanged }, dispatch);
}

const Area = ({ names, events, inviteeRSVPChanged, blueTeamMember }) => {
  const eventObj = {
    ny: 'Wedding',
    ca: 'Preception',
    ba: 'Blue Team',
  };

  names.sort();

  const rows = [];

  for (const eventName of Object.keys(events)) {
    rows.push(
      <div key={eventName} className="rsvp-event-heading">
        <h2>{eventObj[eventName]}</h2>
      </div>,
    );
  }

  for (const name of names) {
    const firstName = name.split(' ')[0];
    rows.push(
      <div key={name} className="rsvp-person">
        <h2 className="small-name">{name}</h2>
        <h2 className="full-name">{firstName}</h2>
      </div>,
    );
    for (const [eventName, value] of Object.entries(events)) {
      let checked = false;
      if (value !== null && value !== undefined) {
        checked = value.includes(firstName);
      }

      let row = null;
      if (
        (eventName === 'ba' && name === blueTeamMember) ||
        eventName !== 'ba'
      ) {
        row = (
          <div key={`${name}-${eventName}`} className="rsvp-event">
            <Checkbox
              name={name}
              event={eventName}
              checked={checked}
              clickFunc={inviteeRSVPChanged.bind(this, eventName, name)}
            />
          </div>
        );
      } else {
        const style = { visibility: 'hidden' };
        row = (
          <div
            key={`${name}-${eventName}`}
            className="rsvp-event"
            style={style}
          >
            <Checkbox
              name={name}
              event={eventName}
              checked={checked}
              clickFunc={inviteeRSVPChanged.bind(this, eventName, name)}
            />
          </div>
        );
      }
      rows.push(row);
    }
  }

  return rows;
};

const TextSection = ({ events, attendees }) => {
  let text;
  if (attendees === 1) {
    if (events === 1) {
      text = `Check the box below to let us know if you'll be attending`;
    } else {
      text = `Check the boxes below to let us know which events you'll be attending`;
    }
  } else {
    if (events === 1) {
      text = `Check the box below to let us know who will be attending`;
    } else {
      text = `Check the boxes below to let us know who will be attending which events`;
    }
  }
  return text;
};

class RSVP extends Component {
  componentWillMount() {
    this.sectionId = `section-${this.props.section}`;
  }

  render() {
    const rows = this.props.names.length;
    const columns = Object.keys(this.props.events).length;

    const styles = {
      '--rsvp-area-rows': rows + 1,
      '--rsvp-area-columns': columns + 1,
    };

    return (
      <section id={this.sectionId}>
        <h1>RSVP</h1>
        <p className="rsvp-area-text">
          <TextSection
            attendees={this.props.names.length}
            events={Object.keys(this.props.events).length}
          />
        </p>
        <p className="rsvp-area-text">
          Simply clicking a box is enough to let us know!
        </p>
        {Object.keys(this.props.events).length > 1 ? (
          <p className="rsvp-area-text">
            There's no obligation to attend both events. The west coast
            preception is intended for those that cannot make it to New York
          </p>
        ) : (
          ''
        )}

        <div className="rsvp-area" style={styles}>
          <div />
          <Area {...this.props} />
        </div>
      </section>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RSVP);



// WEBPACK FOOTER //
// ./src/components/RSVP.js